// @martyrs/src/modules/core/locales/ru.js
export default {
  core: {
    ui: {
      darkMode: 'Тёмная тема',
      // Крестик шапки попапа (PopupHeader).
      popupClose: 'Закрыть',
      // Календарь дизайн-системы.
      back: 'Назад',
      previousMonth: 'Предыдущий месяц',
      nextMonth: 'Следующий месяц',
    },
    errors: {
      USER_NOT_FOUND: 'Такой пользователь не зарегистрирован!',
      USER_ALREADY_REGISTERED: 'Такой пользователь уже зарегистрирован!',
      USER_NOT_REGISTERED_YET: 'Такой пользователь еще не зарегистрирован!',
      USER_PHONE_OR_PASSWORD_NOT_FOUND: 'Пользователь с таким телефоном или паролем не найден!',
      INCORRECT_PASSWORD_ENTERED: 'Вы ввели неверный пароль!',
      AUTH_METHOD_DISABLED: 'Этот способ входа отключён.',
      INVALID_INVITATION_CODE: 'Неверный код приглашения',
      MISSING_REQUIRED_PARAMETERS: 'Отсутствуют необходимые параметры.',
      ERROR_UPDATING_USER: 'Произошла ошибка при обновлении пользователя.',
      PASSWORDS_DO_NOT_MATCH: 'Введенные вами пароли не совпадают. Исправьте ошибки и попробуйте еще раз.',
      CODE_NOT_SENT: 'Что-то пошло не так и код не был отправлен. Попробуйте еще раз.',
      INPUT_ERROR: 'Вставьте только четырехзначный код.',
      WRONG_CODE: 'Вы ввели неверный код. Попробуйте еще раз.',
      POST_URL_ALREADY_IN_USE: 'Ошибка! Публикация с этим URL уже используется!',
      NAME_CANNOT_BE_EMPTY: 'Ошибка: Название не может быть пустым. Пожалуйста, введите название.',
      INVALID_LOCALE: 'Такой язык не поддерживается.',
      INVALID_COUNTRY: 'Такой страны нет в справочнике.',
      COUNTRY_CHANGE_LIMIT: 'Страну можно менять раз в 30 дней',
    },
    timeAgo: {
      now: 'только что',
      minute: '{n} мин назад',
      hour: '{n} ч назад',
      day: '{n} дн назад',
      week: '{n} нед назад',
    }
  },
  footer: {
    description: 'Свяжитесь с нами',
    phoneNumber: '+1 234 567 890',
    emailAddress: "info{'@'}example.com",
    hours_text: 'Пн-Пт: 9:00 - 18:00',
    app: 'Скачайте наше приложение',
    subscribe: 'Подпишитесь на рассылку',
    subscribe_text: 'Будьте в курсе последних новостей и обновлений',
    follow: 'Подписывайтесь',
    year: '2025',
    heart: '♥',
    copyright: 'Все права защищены',
    ozdao: 'Сделано OZ DAO',
    navigationColumns: [
      {
        sections: [
          {
            title: 'Компания',
            items: [
              { name: 'О нас', url: 'about' },
              { name: 'Карьера', url: 'careers' },
              { name: 'Контакты', url: 'contact' }
            ]
          }
        ]
      },
      {
        sections: [
          {
            title: 'Ресурсы',
            items: [
              { name: 'Блог', url: 'blog' },
              { name: 'Помощь', url: 'help' },
              { name: 'Конфиденциальность', url: 'privacy' }
            ]
          }
        ]
      }
    ],
    socialLinks: [
      { name: 'instagram', url: 'https://instagram.com' },
      { name: 'facebook', url: 'https://facebook.com' },
      { name: 'linkedin', url: 'https://linkedin.com' }
    ]
  }
};